// extracted by mini-css-extract-plugin
module.exports = {"modal_body":"Success_modal_body__1ippX","title":"Success_title__yBLef","content":"Success_content__KGFdx","icon":"Success_icon__3TCSN"};